import type { FlowStep } from '@Shared';

// TODO: Load your client flow from the api
// const baseUrl: string = 'api/ClientFlow';

export const getClientFlowApi = async (): Promise<FlowStep[]> => {
    return [
        
        {
            stepName: 'ReviewDocument',
        },
        {
            stepName: 'EnvelopeView',
        },
        {
            stepName: 'EsignatureComplete',
        },
        {
            stepName: 'Dashboard',
        }
    ];
};
